<template>
    <a-table class="submission-table" size="small" :pagination="false"
        :rowClassName="genRowClass" :columns="columns" :data-source="list"
        rowKey="id" :loading="loading"
    >
        <verdict-icon slot="verify" slot-scope="verify" :verify="verify" />
        <a class="tower-title" slot="tower" slot-scope="title, record" :href="`/tower/?name=${ record.name }`" target="_blank">{{ title }}</a>
        <templated-username slot="user" slot-scope="user" :user="user"></templated-username>
        <span slot="timestamp" slot-scope="timestamp">{{ formatDate(timestamp)}}</span>
        <span slot="manage" slot-scope="record">
            <a-button type="danger" size="small"
                :disabled="Number(record.verify) === -1" 
                @click="deleteSubmission(record)"
            ><a-icon type="delete" /></a-button>
        </span>
        <span slot="footer">
            <a-pagination :current="Number($route.query.p)" :total="Number(total)" 
                :defaultPageSize="50" @change="turnPage" :hideOnSinglePage="true"
            />
        </span>
    </a-table>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { checkPrivilege } from '../admin/privilege';
import { createFormData, formatTime } from '../../utils/utils';
import VerdictIcon from '@/components/VerdictIcon.vue';
import TemplatedUsername from '../../components/TemplatedUsername.vue';
import UserLink from '@/components/UserLink.vue';

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.query);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.query);
        next();
    },
    data: () => ({
        list: [],
        loading: false,
        total: 0,
    }),
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        hasManagePrivilege() {
            return checkPrivilege({ submission: 2 }, this.userPrivilege);
        },
        columns() {
            const cols = [
                { dataIndex: 'verify', slot: 'verify' },
                { title: '塔名', dataIndex: 'title', slot: 'tower' },
                { title: '难度', dataIndex: 'hard' },
                { title: '结局', dataIndex: 'ending' },
                { title: '用户名', dataIndex: 'user', slot: 'user' },
                { title: '分数', dataIndex: 'score' },
                { title: '游戏时间', dataIndex: 'totalTime' },
                { title: '提交时间', dataIndex: 'timestamp', slot: 'timestamp' },
            ];
            if (this.hasManagePrivilege) {
                cols.push({
                    title: '管理', slot: 'manage'
                })
            }
            return cols.map(e => e.slot ?
                { ...e, scopedSlots: { customRender: e.slot } } : e
            );
        },
    },
    methods: {
        formatDate(timestamp) {
            return formatTime(timestamp, {
                day: "HH:mm:ss",
                year: "MM/DD HH:mm:ss",
                other: "YYYY/MM/DD HH:mm:ss"
            });
        },
        turnPage(page) {
            this.$router.replace({ query: {
                ...this.$route.query,
                p: page
            } });
        },
        genRowClass(row) {
            if (row.user.id < 0 || row.user.id != this.userid) return '';
            return 'my-submission';
        },
        async load({ p, q, tower }) {
            this.loading = true;
            const { data } = await axios
                .post("/backend/submission/list.php", createFormData({
                    page: p, searchstr: q, name: tower
                }));
            this.total = data.total;
            this.list = data.list;
            this.loading = false;
        },
        async deleteSubmission({ user, id }) {
            this.$confirm({
                title: `确认要删除 ${ user.name } 的提交吗？`,
                onOk: async() => {
                    this.loading = true;
                    try {
                        const { data } = await axios
                            .post("/backend/admin/submission/delete.php", createFormData({
                                id
                            }));
                        if (data.code !== 0) {
                            this.$message.error(`删除失败: ${ data }`);
                        } else {
                            this.$message.success(`删除成功`);
                            this.load();
                        }
                    } catch (e) {
                        this.$message.error(`删除失败: ${ e }`);
                    } finally {
                        this.loading = false;
                    }
                },
                onCancel() {
                    //
                },
            });
        },
    },
    components: {
        VerdictIcon,
        TemplatedUsername,
    },
}
</script>

<style lang="less" scoped>
.submission-table {
    overflow: auto;
    width: 100%;
}
</style>

<style scoped>
.submission-table >>> .my-submission {
    background-color: #E0F2F1;
}
</style>